export default () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
		<path fill="#212121" fillRule="evenodd" d="M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14l-6-6z" clipRule="evenodd" />
	</svg>
);
